import './polyfills';
import moment from 'moment';
import Moment from 'react-moment';
import i18n from 'i18next';
import { createRoot } from 'react-dom/client';
import RegisterRoute from './routes/RegisterRoute';
import * as serviceWorker from './serviceWorker';
import './i18n';
import navigatorObserver from './middleware/navigatorObserver';

const getLanguage = () => {
    const language = (
        i18n.language
        || (typeof window !== 'undefined' && window.localStorage.i18nextLng)
        || 'pt-BR'
    ).toLowerCase();

    switch (language) {
        case 'en':
            return 'en-gb';
        case 'es-ar':
            return 'es';
        default:
            return language;
    }
};
import(`moment/locale/${getLanguage()}`).then();

Moment.globalMoment = moment;
Moment.globalLocale = getLanguage();
navigatorObserver.register();

// Criando o root e renderizando a aplicação
const rootElement = document.getElementById('root');
const root = createRoot(rootElement); // Criando o root
root.render(<RegisterRoute />); // Renderizando a aplicação

serviceWorker.unregister();
